var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6335 0.291491C10.2285 -0.0985088 9.57348 -0.0985088 9.16948 0.291491L0.606481 8.55549C0.414802 8.73765 0.262174 8.9569 0.15788 9.19989C0.053586 9.44289 -0.000196457 9.70456 -0.000196457 9.96899C-0.000196457 10.2334 0.053586 10.4951 0.15788 10.7381C0.262174 10.9811 0.414802 11.2003 0.606481 11.3825L9.23148 19.7075C9.42723 19.8935 9.68645 19.9981 9.9565 20C10.2266 20.0018 10.4872 19.9008 10.6855 19.7175C10.7837 19.627 10.8623 19.5172 10.9164 19.3951C10.9705 19.2729 10.9989 19.141 11 19.0074C11.001 18.8738 10.9746 18.7414 10.9224 18.6184C10.8702 18.4955 10.7933 18.3845 10.6965 18.2925L2.80248 10.6755C2.70656 10.5844 2.63018 10.4747 2.57799 10.3532C2.52579 10.2317 2.49888 10.1008 2.49888 9.96849C2.49888 9.83621 2.52579 9.70532 2.57799 9.58378C2.63018 9.46223 2.70656 9.35258 2.80248 9.26149L10.6335 1.70449C10.7294 1.61349 10.8057 1.50392 10.8579 1.38246C10.9101 1.261 10.937 1.13019 10.937 0.997992C10.937 0.865795 10.9101 0.734982 10.8579 0.61352C10.8057 0.492058 10.7294 0.38249 10.6335 0.291491Z",
    fill: "#663399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.cdd1411f3880838ed05133f0f3cecdde.svg";
export { ForwardRef as ReactComponent };